module.exports = __webpack_public_path__ + "media/points/connect-ddb4ccc3.svg";